<template>
  <v-container grid-list-xl>
    <canvas id="credits-charts"></canvas>
  </v-container>
</template>
<script>
import { EventBus } from "../../utils/event-bus";
import Chart from "chart.js";
export default {
  props: ["power_plants"],
  data: () => ({
    user: {},
    power_plant: "",
    valid: false,
    loading: false,
    invoices: [],
    current_date: new Date(),
    //   ChartData: ChartData,
    ChartData: {
      type: "line", // was "line"
      data: {
        // labels: ['04/2019', '05/2019', '06/2019', '07/2019', '08/2019', '09/2019'],
        labels: ["2019", "2019", "2019", "07/2019", "08/2019", "09/2019"],
        datasets: [
          {
            // one line graph
            label: "Créditos Gerados",
            type: "line", // Add this
            data: [8600, 12000, 12400, 12600, 12200, 11600],
            backgroundColor: [
              "rgba(54,73,93,.5)", // Blue
              // 'rgba(54,73,93,.5)',
              // 'rgba(54,73,93,.5)',
              // 'rgba(54,73,93,.5)',
              // 'rgba(54,73,93,.5)',
              // 'rgba(54,73,93,.5)',
            ],
            borderColor: [
              "#36495d",
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
              // '#36495d',
            ],
            borderWidth: 3,
          },
          {
            // another line graph
            label: "Consumo dos Membros",
            type: "line", // Add this
            data: [14000, 14100, 14400, 14600, 14200, 14600],
            backgroundColor: [
              "rgba(71, 183,132,.5)", // Green
              // 'rgba(71, 183,132,.5)', // Green
              // 'rgba(71, 183,132,.5)', // Green
              // 'rgba(71, 183,132,.5)', // Green
              // 'rgba(71, 183,132,.5)', // Green
              // 'rgba(71, 183,132,.5)', // Green
            ],
            borderColor: ["#47b784"],
            borderWidth: 3,
          },
          {
            // another line graph
            label: "Saldo",
            type: "line", // Add this
            data: [1000, 1100, 1400, 1600, 1200, 600],
            backgroundColor: [
              "red", // Green
            ],
            borderColor: ["#red"],
            borderWidth: 3,
          },
          {
            // another line graph
            label: "Saldo Atual",
            type: "line", // Add this
            data: [1000, 1100, 1400, 1600, 1200, 600],
            // backgroundColor: [
            //     'red', // Green
            // ],
            borderColor: ["#808080"],
            borderDash: [5, 5],
            borderWidth: 3,
          },
        ],
      },
      options: {
        responsive: true,
        lineTension: 1,
        title: {
          display: true,
          text: "Gestão de Créditos Mensal",
          fontSize: 20,
          fontStyle: "bold",
          padding: 10,
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
                padding: 25,
              },
            },
          ],
        },
      },
    },
  }),
  mounted() {
    EventBus.$on("LoadTotalInvoice", (invoices) => {
      this.loading = true;
      this.invoices = invoices;
      var competences_label = this.invoices.map(function (val) {
        return (
          val.competence.split("-")[1] + "/" + val.competence.split("-")[0]
        );
      });
      var saldo = this.invoices.map(function (val) {
        return val.current_balance - val.last_balance;
      });
      var saldo_atual = this.invoices.map(function (val) {
        return val.current_balance;
      });
      var creditos = this.invoices.map(function (val) {
        // return val.power_plant_amount + (val.current_balance - val.last_balance)
        return val.power_plant_amount;
      });
      var consumo = this.invoices.map(function (val) {
        return val.total_consumo_kW;
      });
      // console.log(consumo)

      this.ChartData.data.labels = competences_label;
      // console.log('data: ', this.ChartData.data.datasets)
      this.ChartData.data.datasets[2].data = saldo;
      this.ChartData.data.datasets[1].data = consumo;
      this.ChartData.data.datasets[0].data = creditos;
      this.ChartData.data.datasets[3].data = saldo_atual;
      this.createChart("credits-charts", this.ChartData);
      // console.log('competences_label: ', competences_label)
      // this.setInvoiceTotals(billing.data.billingTotals)
      this.valid = true;
      this.loading = false;
    });
  },

  methods: {
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      // eslint-disable-next-line
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    },
  },
};
</script>
